import { Icon, Columns, Column } from '@codeparva/ui-components-library';
import React from 'react';
import { FaChevronUp } from '@react-icons/all-files/fa/FaChevronUp';
import { LocationTypes } from '../locationTypes';
import { Text } from '../../../../../components/textVariations/components/text/Text';
import { LocationHours } from './LocationHours';
import {
  getClassNameFromTheme,
  getIconColorFromTheme,
} from '../helpers/colorSelectionTheme';
import { Icon as Icons } from '../../../../../utilities/icomoon-css';
import { useVariant } from '../../../../contactUsPage/hooks/VariantContext';

export const FormattedHrs = ({
  onFacilityHrsToggle,
  formattedHrs,
  show = 'both',
  hideToggle = false,
  color = 'white',
  theme,
  titleClassName = '',
  size = 24,
}: LocationTypes.IFormattedHrs) => {
  const variant = useVariant();

  const getMargin = () => {
    return variant === 'newContactUsLightTheme' ? '' : 'ml-3';
  };

  const getHours = (icon: any, title: string) => {
    return (
      <Column className="is-flex pb-3 is-align-items-center">
        {variant === 'newContactUsDarkTheme' && (
          <Icons name={icon} color={color} size={size} />
        )}
        <div className={getMargin()}>
          <h5 className={`${titleClassName} mb-0`}>{title}</h5>
        </div>
      </Column>
    );
  };
  return (
    <div className="hoursContainer">
      {!hideToggle && (
        <Text
          size={6}
          onClick={onFacilityHrsToggle}
          className={`HoursTitle ${getClassNameFromTheme(theme)}`}
        >
          Hours
          <span>
            <Icon
              color={getIconColorFromTheme(theme)}
              renderAs="span"
              title="Click to collapse the facility and gate hours"
            >
              <FaChevronUp size={8} />
            </Icon>
          </span>
        </Text>
      )}
      <Columns vCentered className="is-flex-1 locationHrsContainer">
        {(show === 'both' || show === 'facilityHrsOnly') && (
          <Column className="facilityHoursContainer">
            {formattedHrs.officeHrs.length > 0 &&
              getHours('tfw-unit-bold-cp', 'Facility Hours')}
            <LocationHours facilityHours={formattedHrs.officeHrs} />
          </Column>
        )}
        {(show === 'both' || show === 'gateHrsOnly') && (
          <Column className="accessHoursContainer">
            {formattedHrs.gateHrs.length > 0 &&
              getHours('tfw-clock-cp', 'Access Hours')}
            <LocationHours facilityHours={formattedHrs.gateHrs} />
          </Column>
        )}
      </Columns>
    </div>
  );
};
